export default __webpack_public_path__ + "static/6615-12dab4a73660bfc0b595485f5401f8e8.jpg";